// Messages of the Fretum hub modules. Spanish is the reference; English is the fallback
// for the other locales.
export const hubSpanishMessages = {
  resources: {
    team_tasks: {
      name: "Tarea |||| Tareas",
      fields: {
        title: "Título",
        description: "Descripción",
        status: "Estado",
        priority: "Prioridad",
        assignee_id: "Responsable",
        start_date: "Inicio",
        due_date: "Fecha límite",
        tags: "Etiquetas",
        checklist: "Subtareas",
        deal_id: "Oportunidad",
        company_id: "Empresa",
        milestone_id: "Hito",
        estimate_hours: "Estimación (h)",
        text: "Texto",
        done: "Hecha",
      },
    },
    events: {
      name: "Evento |||| Eventos",
      fields: {
        title: "Título",
        description: "Descripción",
        start_at: "Inicio",
        end_at: "Fin",
        all_day: "Todo el día",
        location: "Lugar",
        kind: "Tipo",
        company_id: "Empresa",
        contact_id: "Contacto",
        deal_id: "Oportunidad",
      },
    },
    deal_milestones: {
      name: "Hito |||| Hitos",
      fields: {
        title: "Hito",
        description: "Descripción",
        due_date: "Fecha objetivo",
        status: "Estado",
        amount: "Importe",
        payment_status: "Cobro",
      },
    },
    delivery_templates: {
      name: "Plantilla de entrega |||| Plantillas de entrega",
      fields: {
        name: "Nombre",
        description: "Descripción",
        milestones: "Hitos",
        title: "Hito",
        offset_days: "Días desde el inicio",
        amount_pct: "% del importe",
        items: "Tareas de entrega",
      },
    },
    project_links: {
      name: "Enlace |||| Enlaces",
      fields: { kind: "Tipo", label: "Nombre", url: "URL", notes: "Notas" },
    },
    time_entries: {
      name: "Registro de horas |||| Horas",
      fields: {
        task_id: "Tarea",
        deal_id: "Oportunidad",
        date: "Fecha",
        hours: "Horas",
        description: "Descripción",
        billable: "Facturable",
        sales_id: "Persona",
      },
    },
    styles: {
      name: "Estilo |||| Estilos",
      fields: {
        name: "Nombre",
        description: "Descripción",
        status: "Estado",
        project_types: "Tipo de proyecto",
        tags: "Etiquetas",
        demo_url: "Demo",
        deal_ids: "Usado en",
        images: "Capturas",
      },
    },
    wiki_pages: {
      name: "Página |||| Wiki",
      fields: {
        title: "Título",
        content: "Contenido",
        category: "Categoría",
        tags: "Etiquetas",
        pinned: "Fijada",
        company_id: "Empresa",
        deal_id: "Oportunidad",
        updated_at: "Actualizada",
      },
    },
    subscriptions: {
      name: "Coste |||| Costes",
      fields: {
        name: "Nombre",
        provider: "Proveedor",
        category: "Categoría",
        amount: "Importe",
        currency: "Moneda",
        billing_period: "Periodicidad",
        next_renewal: "Próxima renovación",
        status: "Estado",
        company_id: "Repercutir a",
        deal_id: "Oportunidad",
        url: "URL",
        notes: "Notas",
      },
    },
    quotes: {
      name: "Presupuesto |||| Presupuestos",
      fields: {
        number: "Número",
        title: "Título",
        status: "Estado",
        deal_id: "Oportunidad",
        company_id: "Cliente",
        issue_date: "Fecha",
        valid_until: "Válido hasta",
        items: "Conceptos",
        description: "Concepto",
        quantity: "Cantidad",
        unit_price: "Precio unitario",
        tax_rate: "IVA (%)",
        notes: "Notas",
        terms: "Condiciones",
      },
    },
    invoices: {
      name: "Factura |||| Facturas",
      fields: {
        number: "Número",
        deal_id: "Oportunidad",
        milestone_id: "Hito",
        company_id: "Cliente",
        issue_date: "Emisión",
        due_date: "Vencimiento",
        amount: "Base imponible",
        tax_rate: "IVA (%)",
        status: "Estado",
        paid_at: "Cobrada el",
        notes: "Notas",
      },
    },
  },
  hub: {
    nav: {
      commercial: "Comercial",
      tasks: "Tareas",
      calendar: "Calendario",
      styles: "Estilos",
      more: "Hub",
    },
    greeting: {
      morning: "Buenos días",
      morning_named: "Buenos días, %{name}",
      afternoon: "Buenas tardes",
      afternoon_named: "Buenas tardes, %{name}",
      evening: "Buenas noches",
      evening_named: "Buenas noches, %{name}",
    },
    common: {
      all: "Todos",
      me: "Yo",
      nobody: "Sin asignar",
      kanban: "Kanban",
      list: "Lista",
      overdue: "Vencida",
      add: "Añadir",
      save: "Guardar",
      cancel: "Cancelar",
      delete: "Eliminar",
      open: "Abrir",
      copy: "Copiar",
      copied: "Copiado",
      total: "Total",
      none: "Ninguno",
      progress: "Avance",
      empty: "Nada por aquí todavía",
      new: "Nuevo",
    },
    status: {
      todo: "Pendiente",
      in_progress: "En curso",
      blocked: "Bloqueada",
      review: "En revisión",
      done: "Hecha",
      pending: "Pendiente",
    },
    priority: {
      low: "Baja",
      medium: "Media",
      high: "Alta",
      urgent: "Urgente",
    },
    payment: {
      none: "Sin cobro",
      pending: "Pendiente de facturar",
      invoiced: "Facturado",
      paid: "Cobrado",
    },
    event_kind: {
      meeting: "Reunión",
      demo: "Demo",
      call: "Llamada",
      internal: "Interno",
      deadline: "Entrega",
      other: "Otro",
    },
    team_tasks: {
      new: "Nueva tarea",
      mine: "Mis tareas",
      checklist_progress: "%{done}/%{total} subtareas",
      comments: "Comentarios",
      add_comment: "Escribe un comentario",
      time: "Horas",
      log_time: "Registrar horas",
      hours_logged: "%{hours} h registradas",
      empty_column: "Sin tareas",
    },
    calendar: {
      title: "Calendario",
      today: "Hoy",
      month: "Mes",
      week: "Semana",
      agenda: "Agenda",
      new_event: "Nuevo evento",
      no_items: "No hay nada en estas fechas",
      more: "+%{count} más",
      sources: {
        event: "Eventos",
        team_task: "Tareas internas",
        task: "Tareas de clientes",
        deal_closing: "Cierres previstos",
        milestone: "Hitos",
        renewal: "Renovaciones",
        invoice_due: "Vencimientos de facturas",
      },
      rescheduled: "Fecha actualizada",
      sources_label: "Tipos en el calendario",
    },
    delivery: {
      title: "Entrega",
      progress: "Avance de la entrega",
      milestones: "Hitos y entregables",
      add_milestone: "Añadir hito",
      add_item: "Añadir tarea de entrega",
      apply_template: "Aplicar plantilla",
      template_applied: "Plantilla aplicada",
      no_milestones:
        "Todavía no hay hitos. Añade uno o aplica una plantilla de entrega.",
      items: "%{done}/%{total} tareas de entrega",
      overdue: "%{smart_count} hito vencido |||| %{smart_count} hitos vencidos",
      on_track: "En plazo",
      at_risk: "En riesgo",
      late: "Retrasado",
      next_due: "Próximo hito: %{date}",
      links: "Repositorio técnico",
      add_link: "Añadir enlace",
      no_links: "Sin enlaces (repo, staging, producción, Supabase…)",
      time: "Horas dedicadas",
      hours: "%{hours} h (%{billable} h facturables)",
      collected: "Cobrado %{paid} de %{total}",
      share: "Compartir avance con el cliente",
      new_quote: "Crear presupuesto",
    },
    link_kind: {
      repo: "Repositorio",
      staging: "Staging",
      production: "Producción",
      supabase: "Supabase",
      cloudflare: "Cloudflare",
      design: "Diseño",
      docs: "Documentación",
      other: "Otro",
    },
    styles: {
      new: "Nuevo estilo",
      status: {
        idea: "Idea",
        prototype: "Prototipo",
        tested: "Probado",
        production: "En producción",
      },
      project_types: {
        crm: "CRM",
        app: "App",
        web: "Web",
        landing: "Landing",
      },
      tokens: "Tokens de diseño",
      colors: "Colores",
      typography: "Tipografía",
      heading_font: "Fuente de títulos",
      body_font: "Fuente de texto",
      radius: "Radio de bordes",
      mode: "Modo",
      light: "Claro",
      dark: "Oscuro",
      color: {
        primary: "Primario",
        secondary: "Secundario",
        accent: "Acento",
        background: "Fondo",
        surface: "Superficie",
        foreground: "Texto",
        muted: "Texto secundario",
        border: "Bordes",
      },
      preview: "Vista previa",
      present: "Modo presentación",
      exit_present: "Salir",
      export: "Exportar",
      export_css: "Variables CSS",
      export_tailwind: "Tema shadcn/Tailwind",
      export_json: "JSON",
      share: "Compartir con un cliente",
      sample: {
        dashboard: "Panel",
        patients: "Pacientes",
        agenda: "Agenda",
        billing: "Facturación",
        appointments_today: "Citas hoy",
        new_patients: "Pacientes nuevos",
        revenue: "Facturado este mes",
        next_appointments: "Próximas citas",
        new_appointment: "Nueva cita",
        search: "Buscar…",
        confirmed: "Confirmada",
        pending: "Pendiente",
        name: "Nombre",
        time: "Hora",
        treatment: "Tratamiento",
        status: "Estado",
        save: "Guardar",
        cancel: "Cancelar",
      },
    },
    wiki: {
      new: "Nueva página",
      preview: "Vista previa",
      categories: {
        general: "General",
        process: "Procesos",
        technical: "Técnico",
        client: "Clientes",
        sales: "Ventas",
        legal: "Legal",
      },
      pinned: "Fijadas",
    },
    subscriptions: {
      new: "Nuevo coste",
      monthly_total: "Gasto mensual equivalente",
      yearly_total: "Gasto anual equivalente",
      categories: {
        hosting: "Hosting",
        domain: "Dominio",
        software: "Software",
        ai: "IA",
        other: "Otro",
      },
      periods: { monthly: "Mensual", yearly: "Anual", one_off: "Pago único" },
      status: { active: "Activa", cancelled: "Cancelada" },
    },
    quotes: {
      new: "Nuevo presupuesto",
      status: {
        draft: "Borrador",
        sent: "Enviado",
        accepted: "Aceptado",
        rejected: "Rechazado",
      },
      print: "Imprimir / PDF",
      subtotal: "Base imponible",
      tax: "IVA",
      total: "Total",
      quote: "Presupuesto",
      valid_until: "Válido hasta %{date}",
      from_milestones: "Rellenar con los hitos de la oportunidad",
    },
    invoices: {
      new: "Nueva factura",
      status: {
        draft: "Borrador",
        issued: "Emitida",
        paid: "Cobrada",
        overdue: "Vencida",
      },
      pending_total: "Pendiente de cobro",
      paid_total: "Cobrado",
      disclaimer:
        "Control interno de cobros: las facturas oficiales se emiten con un programa de facturación homologado.",
    },
    time: {
      new: "Registrar horas",
      total: "Total: %{hours} h",
    },
    gdpr: {
      title: "RGPD",
      progress: "%{done}/%{total} completado",
      region: "Región de los datos",
      items: {
        dpa_signed: "Contrato de encargado del tratamiento firmado",
        supabase_dpa: "DPA de Supabase aceptado",
        eu_region: "Datos alojados en la UE",
        processing_register: "Registro de actividades de tratamiento",
        privacy_policy: "Política de privacidad actualizada",
        patient_consent: "Consentimiento informado de pacientes",
        access_control: "Accesos mínimos y usuarios nominales",
        backups: "Copias de seguridad activas",
        breach_procedure: "Procedimiento ante brechas de seguridad",
        data_retention: "Plazos de conservación definidos",
      },
    },
    share: {
      title: "Enlace público",
      create: "Crear enlace",
      revoke: "Revocar",
      revoked: "Enlace revocado",
      created: "Enlace creado y copiado",
      hint: "Cualquiera con el enlace puede verlo, sin entrar en Avante.",
      not_found: "Este enlace no existe o ha caducado.",
      progress_title: "Avance del proyecto",
      powered_by: "Compartido desde Avante",
    },
    dashboard: {
      my_tasks: "Mis tareas",
      deliveries: "Entregas en curso",
      next_days: "Próximos 7 días",
      no_tasks: "No tienes tareas pendientes",
      no_deliveries: "No hay entregas en curso",
    },
  },
};

type DeepStringRecord<T> = {
  [K in keyof T]: T[K] extends string ? string : DeepStringRecord<T[K]>;
};

export const hubEnglishMessages: DeepStringRecord<typeof hubSpanishMessages> = {
  resources: {
    team_tasks: {
      name: "Task |||| Tasks",
      fields: {
        title: "Title",
        description: "Description",
        status: "Status",
        priority: "Priority",
        assignee_id: "Owner",
        start_date: "Start",
        due_date: "Due date",
        tags: "Tags",
        checklist: "Subtasks",
        deal_id: "Deal",
        company_id: "Company",
        milestone_id: "Milestone",
        estimate_hours: "Estimate (h)",
        text: "Text",
        done: "Done",
      },
    },
    events: {
      name: "Event |||| Events",
      fields: {
        title: "Title",
        description: "Description",
        start_at: "Start",
        end_at: "End",
        all_day: "All day",
        location: "Location",
        kind: "Type",
        company_id: "Company",
        contact_id: "Contact",
        deal_id: "Deal",
      },
    },
    deal_milestones: {
      name: "Milestone |||| Milestones",
      fields: {
        title: "Milestone",
        description: "Description",
        due_date: "Target date",
        status: "Status",
        amount: "Amount",
        payment_status: "Payment",
      },
    },
    delivery_templates: {
      name: "Delivery template |||| Delivery templates",
      fields: {
        name: "Name",
        description: "Description",
        milestones: "Milestones",
        title: "Milestone",
        offset_days: "Days from start",
        amount_pct: "% of amount",
        items: "Work items",
      },
    },
    project_links: {
      name: "Link |||| Links",
      fields: { kind: "Type", label: "Name", url: "URL", notes: "Notes" },
    },
    time_entries: {
      name: "Time entry |||| Time",
      fields: {
        task_id: "Task",
        deal_id: "Deal",
        date: "Date",
        hours: "Hours",
        description: "Description",
        billable: "Billable",
        sales_id: "Person",
      },
    },
    styles: {
      name: "Style |||| Styles",
      fields: {
        name: "Name",
        description: "Description",
        status: "Status",
        project_types: "Project type",
        tags: "Tags",
        demo_url: "Demo",
        deal_ids: "Used in",
        images: "Screenshots",
      },
    },
    wiki_pages: {
      name: "Page |||| Wiki",
      fields: {
        title: "Title",
        content: "Content",
        category: "Category",
        tags: "Tags",
        pinned: "Pinned",
        company_id: "Company",
        deal_id: "Deal",
        updated_at: "Updated",
      },
    },
    subscriptions: {
      name: "Cost |||| Costs",
      fields: {
        name: "Name",
        provider: "Provider",
        category: "Category",
        amount: "Amount",
        currency: "Currency",
        billing_period: "Billing period",
        next_renewal: "Next renewal",
        status: "Status",
        company_id: "Charge to",
        deal_id: "Deal",
        url: "URL",
        notes: "Notes",
      },
    },
    quotes: {
      name: "Quote |||| Quotes",
      fields: {
        number: "Number",
        title: "Title",
        status: "Status",
        deal_id: "Deal",
        company_id: "Client",
        issue_date: "Date",
        valid_until: "Valid until",
        items: "Items",
        description: "Item",
        quantity: "Quantity",
        unit_price: "Unit price",
        tax_rate: "VAT (%)",
        notes: "Notes",
        terms: "Terms",
      },
    },
    invoices: {
      name: "Invoice |||| Invoices",
      fields: {
        number: "Number",
        deal_id: "Deal",
        milestone_id: "Milestone",
        company_id: "Client",
        issue_date: "Issued",
        due_date: "Due",
        amount: "Net amount",
        tax_rate: "VAT (%)",
        status: "Status",
        paid_at: "Paid on",
        notes: "Notes",
      },
    },
  },
  hub: {
    nav: {
      commercial: "Sales",
      tasks: "Tasks",
      calendar: "Calendar",
      styles: "Styles",
      more: "Hub",
    },
    greeting: {
      morning: "Good morning",
      morning_named: "Good morning, %{name}",
      afternoon: "Good afternoon",
      afternoon_named: "Good afternoon, %{name}",
      evening: "Good evening",
      evening_named: "Good evening, %{name}",
    },
    common: {
      all: "All",
      me: "Me",
      nobody: "Unassigned",
      kanban: "Kanban",
      list: "List",
      overdue: "Overdue",
      add: "Add",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      open: "Open",
      copy: "Copy",
      copied: "Copied",
      total: "Total",
      none: "None",
      progress: "Progress",
      empty: "Nothing here yet",
      new: "New",
    },
    status: {
      todo: "To do",
      in_progress: "In progress",
      blocked: "Blocked",
      review: "In review",
      done: "Done",
      pending: "Pending",
    },
    priority: { low: "Low", medium: "Medium", high: "High", urgent: "Urgent" },
    payment: {
      none: "No payment",
      pending: "To invoice",
      invoiced: "Invoiced",
      paid: "Paid",
    },
    event_kind: {
      meeting: "Meeting",
      demo: "Demo",
      call: "Call",
      internal: "Internal",
      deadline: "Deadline",
      other: "Other",
    },
    team_tasks: {
      new: "New task",
      mine: "My tasks",
      checklist_progress: "%{done}/%{total} subtasks",
      comments: "Comments",
      add_comment: "Write a comment",
      time: "Time",
      log_time: "Log time",
      hours_logged: "%{hours} h logged",
      empty_column: "No tasks",
    },
    calendar: {
      title: "Calendar",
      today: "Today",
      month: "Month",
      week: "Week",
      agenda: "Agenda",
      new_event: "New event",
      no_items: "Nothing on these dates",
      more: "+%{count} more",
      sources: {
        event: "Events",
        team_task: "Team tasks",
        task: "Client tasks",
        deal_closing: "Expected closings",
        milestone: "Milestones",
        renewal: "Renewals",
        invoice_due: "Invoice due dates",
      },
      rescheduled: "Date updated",
      sources_label: "Calendar types",
    },
    delivery: {
      title: "Delivery",
      progress: "Delivery progress",
      milestones: "Milestones and deliverables",
      add_milestone: "Add milestone",
      add_item: "Add work item",
      apply_template: "Apply template",
      template_applied: "Template applied",
      no_milestones: "No milestones yet. Add one or apply a delivery template.",
      items: "%{done}/%{total} work items",
      overdue:
        "%{smart_count} overdue milestone |||| %{smart_count} overdue milestones",
      on_track: "On track",
      at_risk: "At risk",
      late: "Late",
      next_due: "Next milestone: %{date}",
      links: "Technical repository",
      add_link: "Add link",
      no_links: "No links (repo, staging, production, Supabase…)",
      time: "Time spent",
      hours: "%{hours} h (%{billable} h billable)",
      collected: "Collected %{paid} of %{total}",
      share: "Share progress with the client",
      new_quote: "Create quote",
    },
    link_kind: {
      repo: "Repository",
      staging: "Staging",
      production: "Production",
      supabase: "Supabase",
      cloudflare: "Cloudflare",
      design: "Design",
      docs: "Docs",
      other: "Other",
    },
    styles: {
      new: "New style",
      status: {
        idea: "Idea",
        prototype: "Prototype",
        tested: "Tested",
        production: "In production",
      },
      project_types: { crm: "CRM", app: "App", web: "Web", landing: "Landing" },
      tokens: "Design tokens",
      colors: "Colors",
      typography: "Typography",
      heading_font: "Heading font",
      body_font: "Body font",
      radius: "Border radius",
      mode: "Mode",
      light: "Light",
      dark: "Dark",
      color: {
        primary: "Primary",
        secondary: "Secondary",
        accent: "Accent",
        background: "Background",
        surface: "Surface",
        foreground: "Text",
        muted: "Muted text",
        border: "Borders",
      },
      preview: "Preview",
      present: "Presentation mode",
      exit_present: "Exit",
      export: "Export",
      export_css: "CSS variables",
      export_tailwind: "shadcn/Tailwind theme",
      export_json: "JSON",
      share: "Share with a client",
      sample: {
        dashboard: "Dashboard",
        patients: "Patients",
        agenda: "Agenda",
        billing: "Billing",
        appointments_today: "Appointments today",
        new_patients: "New patients",
        revenue: "Billed this month",
        next_appointments: "Next appointments",
        new_appointment: "New appointment",
        search: "Search…",
        confirmed: "Confirmed",
        pending: "Pending",
        name: "Name",
        time: "Time",
        treatment: "Treatment",
        status: "Status",
        save: "Save",
        cancel: "Cancel",
      },
    },
    wiki: {
      new: "New page",
      preview: "Preview",
      categories: {
        general: "General",
        process: "Processes",
        technical: "Technical",
        client: "Clients",
        sales: "Sales",
        legal: "Legal",
      },
      pinned: "Pinned",
    },
    subscriptions: {
      new: "New cost",
      monthly_total: "Monthly equivalent spend",
      yearly_total: "Yearly equivalent spend",
      categories: {
        hosting: "Hosting",
        domain: "Domain",
        software: "Software",
        ai: "AI",
        other: "Other",
      },
      periods: { monthly: "Monthly", yearly: "Yearly", one_off: "One-off" },
      status: { active: "Active", cancelled: "Cancelled" },
    },
    quotes: {
      new: "New quote",
      status: {
        draft: "Draft",
        sent: "Sent",
        accepted: "Accepted",
        rejected: "Rejected",
      },
      print: "Print / PDF",
      subtotal: "Subtotal",
      tax: "VAT",
      total: "Total",
      quote: "Quote",
      valid_until: "Valid until %{date}",
      from_milestones: "Fill from the deal milestones",
    },
    invoices: {
      new: "New invoice",
      status: {
        draft: "Draft",
        issued: "Issued",
        paid: "Paid",
        overdue: "Overdue",
      },
      pending_total: "To collect",
      paid_total: "Collected",
      disclaimer:
        "Internal payment tracking: official invoices are issued with certified invoicing software.",
    },
    time: { new: "Log time", total: "Total: %{hours} h" },
    gdpr: {
      title: "GDPR",
      progress: "%{done}/%{total} done",
      region: "Data region",
      items: {
        dpa_signed: "Data processing agreement signed",
        supabase_dpa: "Supabase DPA accepted",
        eu_region: "Data hosted in the EU",
        processing_register: "Record of processing activities",
        privacy_policy: "Privacy policy up to date",
        patient_consent: "Patients' informed consent",
        access_control: "Least-privilege, named user accounts",
        backups: "Backups enabled",
        breach_procedure: "Data breach procedure",
        data_retention: "Retention periods defined",
      },
    },
    share: {
      title: "Public link",
      create: "Create link",
      revoke: "Revoke",
      revoked: "Link revoked",
      created: "Link created and copied",
      hint: "Anyone with the link can see it without signing in to Avante.",
      not_found: "This link does not exist or has expired.",
      progress_title: "Project progress",
      powered_by: "Shared from Avante",
    },
    dashboard: {
      my_tasks: "My tasks",
      deliveries: "Deliveries in progress",
      next_days: "Next 7 days",
      no_tasks: "You have no pending tasks",
      no_deliveries: "No deliveries in progress",
    },
  },
};
